import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AlertBox from "../../Components/Alert";
import { CAMPUS_LISTS } from "../../Actions/campusAction";
import { sendContact } from "../../Actions/contactAction";
import { CREATE_CONTACT_RESET } from "../../Constants/contactConstant";
import { target_country_codeJson } from "../../Models/contactModel";

export default function CreateCourse({
  FormOpener,
  setFormOpener,
  PartnerForm,
  setPartnerForm,
}) {
  const [Alert, setAlert] = useState([]);

  const { Country_List } = useSelector((state) => state.COUNTRY_LIST_REDUCER);
  const { loading, success, error } = useSelector((s) => s.sendContactReducer);
  const dispatch = useDispatch();

  const handleFormChange = (e) => {
    setPartnerForm({
      ...PartnerForm,
      [e.target.name]: e.target.value,
    });

    if (e.target.name === "University_Id") {
      if (e.target.value === "") {
        dispatch(CAMPUS_LISTS(-1));
      } else {
        dispatch(CAMPUS_LISTS(e.target.value));
      }
    }
    setAlert([]);
  };

  const handleCancel = () => {
    setPartnerForm({});
    setAlert([]);
    setFormOpener(false);
  };

  /*  Course Create Error and Success handle start  */
  const handleFormSubmit = (e) => {
    e.preventDefault();
    dispatch(sendContact({ ...PartnerForm, Partner_Id: 5 }));
  };

  useEffect(() => {
    if (error) {
      setAlert([error]);
    }
    if (success) {
      setAlert([success]);
      setTimeout(() => {
        dispatch({ type: CREATE_CONTACT_RESET });
        handleCancel();
      }, 3000);
    }
  }, [success, error, dispatch]);

  return (
    <>
      <div
        id="CreatContact"
        className={FormOpener ? "overlay-note w100 " : "overlay-note"}
      >
        <div className="Alert">
          {Alert.length > 0
            ? Alert.map((el, i) => (
                <AlertBox
                  key={i}
                  alert={el}
                  validator={success ? true : false}
                />
              ))
            : ""}
        </div>
        <div className="overlay-add-deals contact-right-side">
          <div className="note-title">
            <h4 className="text-left text-white pl-3">
              Send To Affiliate Partner
            </h4>
            <button
              href="#"
              className="closebtn text-right text-white"
              disabled={loading}
              onClick={() => {
                handleCancel();
              }}
            >
              &times;
            </button>
          </div>

          <div className="contact-body modify-create-contact">
            <form onSubmit={handleFormSubmit}>
              <div className="form-group">
                <label>
                  Name:<b>*</b>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Contact Name"
                  name="name"
                 
                  value={PartnerForm.name}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>

              <div className="form-group">
                <label>
                  {"Email Address"}:<b>*</b>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Email Address"
                  name={"email"}
                
                  value={PartnerForm.email}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>
              <div className="form-group">
                <label>
                  {"Phone No"}:<b>*</b>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="mobile number"
                  name={"mobile_number"}
              
                  value={PartnerForm.mobile_number}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>

              <div className="form-group">
                <label>
                  {"Country"}:<b>*</b>
                </label>

                <select
                  className="form-control"
                  placeholder="mobile number"
                  name={"target_country_code"}
                  value={PartnerForm.target_country_code}
                  onChange={(e) => handleFormChange(e)}
                >
                  <option value="">Select</option>
                  {target_country_codeJson?.map((ev, i) => (
                    <option key={i + 89} value={ev.code3}>
                      {ev.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>
                  {"amount"}:<b>*</b>
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="amount"
                  name={"amount"}
                  value={PartnerForm.amount}
                  onChange={(e) => handleFormChange(e)}
                />
              </div>

              <div className="form-group">
                <label>
                  {"Note"}:<b>*</b>
                </label>
                <textarea
                  row={3}
                  className="form-control"
                  placeholder="note"
                  name={"note"}
                  value={PartnerForm.note}
                  onChange={(e) => handleFormChange(e)}
                ></textarea>
              </div>
              <div className="form-group" style={{ height: "200px" }}></div>

              <div className="contact-footer w-100">
                <button type="submit" disabled={loading} className="btn">
                  {loading ? "Loading..." : "Send Contact"}
                </button>

                <button
                  type="button"
                  disabled={loading}
                  className="btn btn-deep-orange waves-effect waves-light"
                  onClick={() => handleCancel()}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
